import React from "react";
import "./PortfolioBoxNew.scss";

function PortfolioBoxNew(props) {
  return (
    <div className={`portfolio_wapper_new`}>
      <div className={`outbox ${props.side}`}>
        <div className="innerbox">
          {props.icon ?
            props?.icon
            :
            <img src={props.Image} alt={props.alt} title={props.cap} />
          }
          <p>{props.Name}</p>
        </div>
      </div>
    </div>
  );
}
export default React.memo(PortfolioBoxNew);
